import React from 'react';
import DocumentPage from '../../components/DocumentPage';

const SalesOrders = () => {
  const columns = [
    { key: 'total', label: 'Total', type: 'currency' },
    { key: 'delivery_date', label: 'Delivery Date', type: 'date' },
  ];

  const formFields = [
    { name: 'client_id', label: 'Client', type: 'party', required: true },
    { name: 'subtotal', label: 'Subtotal', type: 'number', defaultValue: 0 },
    { name: 'tax', label: 'Tax', type: 'number', defaultValue: 0 },
    { name: 'total', label: 'Total', type: 'number', defaultValue: 0 },
    { name: 'delivery_date', label: 'Delivery Date', type: 'date' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'pending',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'confirmed', label: 'Confirmed' },
        { value: 'processing', label: 'Processing' },
        { value: 'shipped', label: 'Shipped' },
        { value: 'delivered', label: 'Delivered' },
        { value: 'cancelled', label: 'Cancelled' },
      ],
    },
  ];

  return (
    <DocumentPage
      title="Sales Orders"
      description="Manage customer orders with print and email"
      apiEndpoint="sales-orders"
      partyType="client"
      partyApi="clients"
      columns={columns}
      formFields={formFields}
      docType="sales_order"
        lineItemsEnabled
    />
  );
};

export default SalesOrders;
